import React from 'react';
import ReactDOM from 'react-dom';

import ControlButtonClose from "../../../core/gd-components/buttons/control-button/close";
import {ModalPlacement, ModalV5_Params} from "./v5/@types";
import closeModal from "../../../core/gd/utils/close-modal";
import stopPropagation from "../../../core/gd/utils/stop-propagation";

const { when, Deferred } = require('simply-deferred');

// const debug = "ModalApp"
const debug = false

export const BUS_MODAL_HIDE = 'gd-modal:hide'
export const BUS_MODAL_SHOW = 'gd-modal:show'

export enum ModalType {

    V5      = 'v5'

}

export default class AppModal {

    public title            : string    = ''

    public component        : any
    public componentParams  : any
    public layout: string   = ''

    // iconComponent: 'any',                   // to remove
    public isOpen: boolean = false        // current modal status
    public className: string    = ''

    public modalType: string    = ''           // po idee vse v3 i v4 dolzni bit'... no mnogo i starih gd. modal. show( poisk esli sdelat' ... dohuya !
    public modalName: string    = ''
    public params?          : ModalV5_Params

    public toggleCallaback? : callback           // if passed will call with true (open) false (hidden) argument

    private DOMContainer        : any
    private header        : any

    constructor() {

    }



    // this.modalType
    // ORIGINAL - old...
    // v3 - new without overlays for app and blur... just add color bg to modal itself

    init() {

        this.DOMContainer = document.getElementById("ui-modal");

        return this;
    }

    _removeClass(className:string) {
        this.DOMContainer.classList.remove(className);
    }

    _removeAllClasses() {
        this.DOMContainer.removeAttribute("class");
    }

    _addClass(className:string) {
        this.DOMContainer.classList.add(className);
    }

    loadAndShow(componentLoader:any, cssFile:string|boolean, content:any) {
        this._addClass("visible");
        this._addClass(content.modalType);
        this.renderLoading();

        const loadChunk = (packFunction:any) => {
            const chunkLoader = new Deferred();
            packFunction().then(
                (component:any)=>{chunkLoader.resolve(component.default)}
                , (error:any) => {
                    chunkLoader.reject()
                    console.log("ERROR LOADING CHUNK", error)
                }
            );
            return chunkLoader;
        };

        // @ts-ignore
        const cssLoader = cssFile?gd.skin.loadDeferred(cssFile, cssFile):true;

        when(loadChunk(componentLoader), cssLoader).then((component:any)=>{
            content.component = component;
            this._show(content);
        });
    }

    showV5(modalContent: any, params?:ModalV5_Params) {

        // this.modalName = content.name;
        this.component          = modalContent
        this.params             = params

        this.modalType          = ModalType.V5
        this.modalName          = params?.name || 'unknown-modal'
        this.toggleCallaback    = params?.toggleCallback

        // this.className = (params.className)?params.className:null;
        // this.componentParams = params.params;

        // this.title = params.title; // not used in V4
        // this.layout = (params.layout)?params.layout:'standard'; // not used in v4
        // this.iconComponent = content.iconComponent; // not used in v4

        // this.header = params.header?params.header:false;

        this.isOpen = true;

        this.render();

        if (this.toggleCallaback) this.toggleCallaback(true);

        gd.bus.triggerEvent(BUS_MODAL_SHOW, this.modalName);


    }

    showV4(content:any) {
        content.modalType = 'v4';
        this._show(content);
    }

    showGeneric(content:any) {
        content.modalType = 'generic';
        this._show(content);
    }

    showConfirm(content:any) {
        content.modalType = 'confirm';
        this._show(content);
    }

    // Deprecated
    showForm(content:any) {
        content.modalType = 'form';
        this._show(content);
    }

    showFullHeight(content:any) {
        content.modalType = 'full-height';
        this._show(content);
    }

    _show(content:any) {

        this.modalName          = content.name;
        this.component          = content.component;
        this.modalType          = (content.modalType)?content.modalType:'original';
        this.toggleCallaback    = (content.toggleCallback)?content.toggleCallback:null;
        this.className          = (content.className)?content.className:null;
        this.componentParams    = content.params;

        this.title = content.title; // not used in V4
        this.layout = (content.layout)?content.layout:'standard'; // not used in v4
        // this.iconComponent = content.iconComponent; // not used in v4

        this.header = content.header?content.header:false;


        this.isOpen = true;

        this.render();

        if (this.toggleCallaback) this.toggleCallaback(true);

        gd.bus.triggerEvent(BUS_MODAL_SHOW, this.modalName);
    }

    hide(callback?:callback) {

        gd.modal.isOpen = false;

        if (this.modalType=='original') {
            gd.bus.triggerEvent("app-remove-blur");
        }

        this.render();

        // hm... we use it but can be refactored I think
        callback?.()


        if (gd.modal.toggleCallaback) gd.modal.toggleCallaback(false); // sometimes we need to know if modal is open ie. when trigger modal from popover so not to close popover
        gd.bus.triggerEvent(BUS_MODAL_HIDE, this.modalName);
    }

    hideOnClick = () => {
        this.hide();
    }

    onContentClick(e:React.SyntheticEvent) {
        e.stopPropagation();
    }

    renderV4() {
        const Component = this.component;
        ReactDOM.render(
            <div className="bg-v4" onClick={this.hideOnClick.bind(this)}>
                <Component params={this.componentParams} className={this.className} />
            </div>
            , this.DOMContainer
        );
    }

    renderV5() {

        const placement = this.params?.placement || ModalPlacement.MIDDLE

        const className = Classes('bg-v5',{
            'placement-middle'      : placement === ModalPlacement.MIDDLE,
            'placement-top'         : placement === ModalPlacement.TOP,
        })

        ReactDOM.render(
            <div className={className} onClick={this.hideOnClick}>
                {this.component}
            </div>
            , this.DOMContainer
        );
    }

    renderConfirm() {
        const Comp = this.component;
        let header : any = false;

        // const preventDefault = (e:React.SyntheticEvent) => {
        //     e.preventDefault()
        // }

        if (this.header) {
            header =(
                <div className="header position-relative" onClick={stopPropagation}>
                    <div className="title ui5-title-app-name">{this.header.title}</div>
                    {/*<div className="i5-delete"></div>*/}

                    <div className="position-absolute t-5 r-5">
                        <ControlButtonClose onClick={closeModal} />
                    </div>

                </div>
            );
        }

        ReactDOM.render(
            <div className="overlay" onClick={this.hideOnClick.bind(this)}>

                <div className="container">
                    {header}
                    <div className="content" onClick={this.onContentClick}>
                        <Comp {...this.componentParams} />
                    </div>
                </div>
            </div>, this.DOMContainer
        );
    }

    renderForm() {
        const Comp = this.component;
        let header : any = false;

        if (this.header) {
            header =(
                <div className="header">
                    <div className="title">{this.header.title}</div>
                    <div className="i5-delete" onClick={this.hideOnClick.bind(this)}></div>
                </div>
            );
        }

        ReactDOM.render(
            <div className="overlay" onClick={this.hideOnClick.bind(this)}>

                <div className="container" onClick={e=>e.stopPropagation()}>
                    {header}
                    <div className="content" onClick={this.onContentClick}>
                        <Comp {...this.componentParams} />
                    </div>
                </div>
            </div>, this.DOMContainer
        );
    }

    renderFullHeight() {
        const Comp = this.component;


        let header : any = false;

        if (this.header) {

            header =(
                <div className="header">
                    <div className="title ui5-title-app-name">{this.header.title}</div>
                    <ControlButtonClose className="btn-close" onClick={this.hideOnClick.bind(this)} />
                </div>
            );

        }

        ReactDOM.render(
            <div className="overlay" onClick={this.hideOnClick.bind(this)}>

                <div className="container" onClick={this.onContentClick}>
                    {header}
                    <div className="content">
                        <Comp params={this.componentParams} {...this.componentParams} />
                    </div>
                </div>
            </div>, this.DOMContainer
        );

    }

    renderGeneric() {
        const Comp = this.component;


        let header : any = false;

        if (this.header) {

            header =(
                <div className="header">
                    <div className="title">{this.header.title}</div>
                    <div className="i5-delete"> </div>
                </div>
            );

        }

        ReactDOM.render(
            <div className="overlay" onClick={this.hideOnClick.bind(this)}>

                <div className="container">
                    {header}
                    <div className="content" onClick={this.onContentClick}>
                        <Comp params={this.componentParams} {...this.componentParams}/>
                    </div>
                </div>
            </div>, this.DOMContainer
        );

    }

    renderClosed() {
        ReactDOM.render(
            <div className="no-content"></div>,this.DOMContainer
        );
    }

    renderLoading() {
        ReactDOM.render(
            <div className="bg-v4" onClick={this.hideOnClick.bind(this)}>
                <div className="v4-container placement-middle">
                    <div className="loading-container">
                        <div className="loading-block">
                            <img className="loading-image" src="/app/web/skin/common/loader/app-loading.gif" />
                            <div className="loading-label">Loading...</div>
                        </div>
                    </div>
                </div>
            </div>, this.DOMContainer
        );
    }

    render() {

        debug && console.log(debug, "render()", this.isOpen);

        if (this.isOpen) {

            this._addClass("visible");

            switch (this.modalType) {

                case 'full-height':
                    this._addClass("modal-full-height");
                    if (this.header) this._addClass('with-header');
                    if (this.className) this._addClass(this.className); // yes modal class goes here !
                    return this.renderFullHeight();

                case 'confirm':
                    this._addClass("modal-confirm");
                    if (this.className) this._addClass(this.className); // yes modal class goes here !
                    return this.renderConfirm();

                case 'form':
                    this._addClass("modal-form");
                    if (this.className) this._addClass(this.className); // yes modal class goes here !
                    return this.renderForm();

                case 'generic':
                    this._addClass("modal-generic");
                    if (this.header) this._addClass('with-header');
                    if (this.className) this._addClass(this.className); // yes modal class goes here !
                    return this.renderGeneric();

                case 'v4':
                    this._addClass("v4");
                    if (this.className) this._addClass(this.className); // yes modal class goes here !
                    return this.renderV4();

                case ModalType.V5:
                    return this.renderV5();

                default:
                    console.error("Unknown modal type");
                    break;

            }

        } else {
            this._removeAllClasses();
            this.renderClosed();
        }

    }

}
